// noinspection JSUnusedLocalSymbols,JSUnresolvedVariable

/**
 * Contains creatives logic JS routines.
 *
 * @package Swan
 */
'use strict'

document.addEventListener( 'DOMContentLoaded', function () {

	/**
	 * Creatives catalog init.
	 */
	( function creativesCatalogInit() {

		/**
		 * The logic for the creatives search.
		 */

		const pageItemsContainer = document.querySelector( '.creatives-page__items' );
		if ( ! pageItemsContainer ) {
			return;
		}

		/**
		 * The logic for the creatives' pagination.
		 */

		/**
		 * Pagination element.
		 *
		 * @type {Element}
		 */
		const paginationElement = document.querySelector( '.creatives-page .page-numbers' );

		/**
		 * Default nodes.
		 *
		 * @type {Element[]}
		 */
		let defaultNodes = [];
		for ( const child of pageItemsContainer.childNodes ) {
			defaultNodes.push( child );
		}

		const searchInput = document.querySelector('.creatives-page__creatives-search');
		searchInput.addEventListener( 'input', function () {
			const searchTerm = this.value.toLowerCase();

			if ( searchTerm ) {

				// Delete the previous nodes.

				for ( const child of  [ ...pageItemsContainer.childNodes ] ) {
					child.remove();
				}

				// Add the HTML.
				let HTMLToAdd = '';

				// Use the keys array to maintain the original order
				for ( const key of swanCreatives.keys ) {
					const value = swanCreatives.list[ key ];
					if ( value && value.toLowerCase().includes( searchTerm ) ) {
						HTMLToAdd += swanCreatives.html[ key ];
					}
				}

				if ( ! HTMLToAdd ) {
					HTMLToAdd = '<p class="swan-no-result-found-text">Geen resultaten gevonden</p>';
				}

				pageItemsContainer.insertAdjacentHTML( 'afterbegin', HTMLToAdd )

				// Hide the pagination.

				paginationElement.hidden = true
			} else {

				// Get default nodes from the temp variable and add to the HTML.

				pageItemsContainer.innerHTML = '';
				defaultNodes.forEach( defaultNode => {
					pageItemsContainer.append( defaultNode );
				} )

				// Show the pagination.

				paginationElement.hidden = false
			}
		} )
	} ) ();

	/**
	 * Init creative profile.
	 */
	( function creativeProfileInit() {
		/**
		 * Add socials tooltips.
		 */
		document.querySelectorAll( '.creative-page__contact-info-block-icon' ).forEach( contactInfoBlock => {
			tippy( contactInfoBlock, {
				content: contactInfoBlock.getAttribute( 'data-tooltip-value' ),
				allowHTML: true,
				theme: 'light',
				placement: 'top'
			} );
		} );
	} ) ();

	/**
	 * Add "Read more" link to the creative description on the products page.
	 */
	const productCreatorInfoInnerWrapper = jQuery( '.product-creator__info-inner-wrapper' );
	if ( productCreatorInfoInnerWrapper && productCreatorInfoInnerWrapper.readmore ) {
		productCreatorInfoInnerWrapper.readmore(
			{
				moreLink: '<a href="#">Lees meer</a>',
				lessLink: '<a href="#">Sluiten</a>'
			}
		);
	}
} );
